import React from 'react';
import { Dumbbell, UserCheck, HeartHandshake, BadgeIndianRupee, Target } from 'lucide-react';
import { aboutFeatures, aboutImage } from '../data/mock';

const iconMap = { Dumbbell, UserCheck, HeartHandshake, BadgeIndianRupee, Target };

export default function About() {
  return (
    <section id="about" className="relative bg-white py-20 md:py-32 overflow-hidden">
      <div className="absolute -top-32 -right-32 w-72 h-72 md:w-96 md:h-96 rounded-full bg-blue-100/60 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
        <div>
          <p className="section-eyebrow text-blue-600">01 — About Us</p>
          <h2 className="mt-4 font-anton text-3xl sm:text-4xl md:text-6xl leading-[0.95] text-slate-900">
            BUILT TO MAKE YOU <span className="text-blue-600">STRONGER</span>
          </h2>
          <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-lg">
            BODY LINE GYM is dedicated to helping people build strength, improve fitness, and achieve a healthier lifestyle. Our experienced trainers, modern equipment, and supportive environment make us one of the best fitness destinations in the area.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {aboutFeatures.map((f) => {
              const Icon = iconMap[f.icon] || Dumbbell;
              return (
                <div key={f.label} className="inline-flex items-center gap-2.5 pl-2 pr-4 py-2 rounded-full bg-blue-50 border border-blue-100 text-slate-700 hover:border-blue-300 hover:shadow-md transition">
                  <span className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-blue-600 shadow-sm">
                    <Icon className="w-4 h-4" />
                  </span>
                  <span className="text-sm font-medium">{f.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-4 bg-gradient-to-br from-blue-200 to-blue-50 rounded-3xl blur-2xl opacity-70 pointer-events-none" />
          <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-slate-200">
            <img src={aboutImage} alt="Inside Body Line Gym" className="w-full h-[280px] md:h-[420px] object-cover grayscale-[15%]" />
          </div>
          <div className="absolute -bottom-5 left-3 md:left-6 bg-white rounded-2xl shadow-2xl px-4 md:px-5 py-3 md:py-4 ring-1 ring-slate-100">
            <p className="font-anton text-2xl md:text-3xl text-blue-600 leading-none">1000<span className="text-slate-900">+</span></p>
            <p className="text-[10px] md:text-xs text-slate-500 mt-1">Members Transformed</p>
          </div>
        </div>
      </div>
    </section>
  );
}
